import { createSelector } from "reselect";
import { Common } from "../../models/";

const selectCommon = (state: any): Common => state.common;

export const selectActiveTab = createSelector(
  [selectCommon],
  (common) => common.activeTab
);

export const selectBranches = createSelector(
  [selectCommon],
  (common) => common.branches
);

export const selectVarieties = createSelector(
  [selectCommon],
  (common) => common.varieties
);
export const selectCrops = createSelector(
  [selectCommon],
  (common) => common.crops
);
export const selectCropsUnit = createSelector(
  [selectCommon],
  (common) => common.cropsUnit
);
export const selectBagList = createSelector(
  [selectCommon],
  (common) => common.bagTypeList
);
export const selectSelectedCrop = createSelector(
  [selectCommon],
  (common) => common.selectedCrop
);
export const selectSelectedDelivery = createSelector(
  [selectCommon],
  (common) => common.selectedDeliveryStatus
);
export const selectSelectedPo = createSelector(
  [selectCommon],
  (common) => common.selectedPoStatus
);
export const selectSelectedPayment = createSelector(
  [selectCommon],
  (common) => common.selectedPayment
);
export const selectSelectedSaudha = createSelector(
  [selectCommon],
  (common) => common.selectedSaudaType
);
export const selectBranch = createSelector(
  [selectCommon],
  (auction) => auction.selectedBranch
);
export const selectInitialDataLoaded = createSelector(
  [selectCommon],
  (common) => common.initialDataLoaded
);
export const selectSupplierBidsData = createSelector(
  [selectCommon],
  (common) => common.supplierBidsData
);
export const selectHubs = createSelector(
  [selectCommon],
  (common) => common.hubs
);
export const selectTC = createSelector([selectCommon], (common) => common.tc);
export const selectPrivacyPolicy = createSelector(
  [selectCommon],
  (common) => common.privacyPolicy
);
export const selectLoading = createSelector(
  [selectCommon],
  (common) => common.loading
);
export const selectSuccessMsg = createSelector(
  [selectCommon],
  (common) => common.succcess
);
export const selectErrorMsg = createSelector(
  [selectCommon],
  (common) => common.error
);
export const selectAuctionBid = createSelector(
  [selectCommon],
  (common) => common.activeBidsData
);
export const selectParameters = createSelector(
  [selectCommon],
  (common) => common.parameters
);